import type {
  Router as VueRouter,
  RouteLocationRaw,
  RouteLocationNormalized,
  LocationQueryRaw,
} from "vue-router";

let router: VueRouter | null = null;

export function setRouter(r: VueRouter) {
  router = r;
  return r;
}

export function navigateTo(args: RouteLocationRaw, replace = false) {
  router?.[replace ? "replace" : "push"](args);
}

export function appendQuery(route: RouteLocationNormalized, query: LocationQueryRaw) {
  navigateTo({
    name: route.name as any,
    hash: route.hash,
    path: route.path,
    params: route.params,
    query: {
      ...(route.query || {}),
      ...query,
    },
  } as any);
}

export function replaceQuery(route: RouteLocationNormalized, query: LocationQueryRaw) {
  navigateTo({
    name: route.name as any,
    hash: route.hash,
    path: route.path,
    params: route.params,
    query,
  } as any);
}
